import React from "react";
import { useNavigate } from "react-router";

export const useDashboardControllers = () => {
  const navigate = useNavigate();

  const [showCompanyCard, setShowCompanyCard] = React.useState(true);
  const [hasMounted, setHasMounted] = React.useState(false);
  const [dateRange, setDateRange] = React.useState<[Date | null, Date | null]>([null, null]);

  const handleDateRangeChange = (range: [Date | null, Date | null]) => {
    setDateRange(range);
  };


  const toggleCompanyCard = () => {
    setShowCompanyCard((prev) => !prev);
  };


  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  return {
    navigate,
    showCompanyCard,
    hasMounted,
    dateRange,

    // function
    toggleCompanyCard,
    handleDateRangeChange
  };
};
